import React from "react";
import { images } from "../assets";
import debounce from "lodash.debounce";
const SButton = (props) => {
  const { src } = props;

  return (
    <button
      {...props}
      onClick={debounce(
        () => {
          props.onClick && props.onClick();
        },
        500,
        {
          leading: true,
          trailing: false,
        }
      )}
    />
  );
};

export default SButton;
